import os from '@edu-fe/os'
import loginApp from './login-app'
import loginBrowser from './login-browser'
import loginWeixin from './login-weixin'
import { log } from './utils'

/**
 * @param {Object}   options 选项
 * @param {Function} options.callback 回调, 仅 APP 内可用
 * @param {String}   options.backUrl 登录完成要跳转的页面链接, 仅浏览器和微信可用
 * @return {Promise} 登录状态
 */

export default function login (options = {}) {
  const { callback, backUrl = window.location.href } = options
  console.log('os type:' + os.type)
  switch (os.type) {
    case 'app':
      return loginApp(callback)
    case 'ali':
    case 'browser':
      return loginBrowser(backUrl)
    case 'weixin':
      return loginWeixin(backUrl)
    default:
      log('暂无可用的登录方式')
  }
}
